import { render, staticRenderFns } from "./BeeSimpleTable.vue?vue&type=template&id=92907080&scoped=true"
import script from "./BeeSimpleTable.vue?vue&type=script&lang=js"
export * from "./BeeSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92907080",
  null
  
)

export default component.exports